export default __webpack_public_path__ + "static/4_17-71b1aae18776d80d0c007d1a8a1969be.png";